var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"pop-container"},[_c('div',{staticClass:"message-container"},[_c('span',{staticClass:"message-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }